import axios from 'axios';
import { getToken, removeToken } from './auth';

// Базовый URL для API (относительный для nginx проксирования)
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor для добавления токена авторизации
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor для обработки ошибок авторизации
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Токен невалидный или истек
      removeToken();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth endpoints
export const authAPI = {
  login: (username, password) =>
    api.post('/admin/auth/login', { username, password }),
  
  verify2FA: (sessionToken, token) =>
    api.post('/admin/auth/verify-2fa', { session_token: sessionToken, token }),
  
  setup2FA: (password) =>
    api.post('/admin/auth/setup-2fa', { password }),
  
  enable2FA: (token) =>
    api.post('/admin/auth/enable-2fa', { token }),
  
  getMe: () =>
    api.get('/admin/auth/me'),
};

// Dashboard endpoints
export const dashboardAPI = {
  getServicesHealth: () =>
    api.get('/admin/health'),
  
  getCacheInfo: () =>
    api.get('/admin/cache'),
  
  getMetrics: () =>
    api.get('/admin/metrics'),
  
  getCacheStats: () =>
    api.get('/admin/cache-stats'),
  
  getQueuesInfo: () =>
    api.get('/admin/queues'),
  
  getSystemMetrics: () =>
    api.get('/admin/system'),
};

// Management endpoints
export const managementAPI = {
  getUsers: (skip = 0, limit = 100) =>
    api.get('/admin/users', { params: { skip, limit } }),
  
  getUser: (userId) =>
    api.get(`/admin/users/${userId}`),
  
  getStrategies: (skip = 0, limit = 100) =>
    api.get('/admin/strategies', { params: { skip, limit } }),
  
  getStrategy: (strategyId) =>
    api.get(`/admin/strategies/${strategyId}`),
};

// Admin Users endpoints
export const adminUsersAPI = {
  getAdminUsers: (skip = 0, limit = 100) =>
    api.get('/admin/admin-users', { params: { skip, limit } }),
  
  getAdminUser: (adminId) =>
    api.get(`/admin/admin-users/${adminId}`),
  
  createAdminUser: (data) =>
    api.post('/admin/admin-users', data),
  
  updateAdminUser: (adminId, data) =>
    api.put(`/admin/admin-users/${adminId}`, data),
  
  deleteAdminUser: (adminId) =>
    api.delete(`/admin/admin-users/${adminId}`),
  
  resetPassword: (adminId, newPassword) =>
    api.post(`/admin/admin-users/${adminId}/reset-password`, { new_password: newPassword }),
};

// Celery: очередь и активные задачи
export const celeryAPI = {
  getOverview: () =>
    api.get('/admin/celery/overview'),

  revoke: (taskId, terminate = true) =>
    api.post('/admin/celery/revoke', { task_id: taskId, terminate }),

  cancelFinderRun: (runId) =>
    api.post(`/admin/celery/finder-runs/${runId}/cancel`),

  purge: () =>
    api.post('/admin/celery/purge'),
};

// Профиль и системные настройки
export const profileAPI = {
  changePassword: (currentPassword, newPassword) =>
    api.post('/admin/auth/change-password', { current_password: currentPassword, new_password: newPassword }),

  getSystemTelegram: () =>
    api.get('/admin/settings/system-telegram'),

  saveSystemTelegram: (data) =>
    api.put('/admin/settings/system-telegram', data),

  testSystemTelegram: () =>
    api.post('/admin/settings/system-telegram/test'),

  getFeatureFlags: () =>
    api.get('/admin/settings/feature-flags'),

  setFeatureFlag: (name, enabled) =>
    api.put('/admin/settings/feature-flags', { name, enabled }),
};

export default api;

